import React from "react";

const principles = ["P1", "P2", "P3", "P4", "P5", "P6", "P7", "P8", "P9"];

const defaultDisclosureData = [
  {
    question: "1a. Does Your Policy Cover NGRBC Principles and Core Elements?",
    type: "toggle",
    values: {},
  },
  { question: "1b. Board-Approved Policy?", type: "toggle", values: {} },
  {
    question: "1c. Web Link of the Policies, if available",
    type: "text",
    values: {},
  },
  {
    question: "2. Is Policy Translated into Procedures?",
    type: "toggle",
    values: {},
  },
  {
    question: "3. Do these policies apply to your value chain partners?",
    type: "toggle",
    values: {},
  },
  {
    question:
      "4. List the National & International codes, certifications, labels, or standards (e.g., FSC, Fairtrade, Rainforest Alliance, SA 8000, ISO) adopted by your entity and aligned with each principle.",
    type: "text",
    values: {},
    title:
      "List the National & International codes, certifications, labels, or standards (e.g., FSC, Fairtrade, Rainforest Alliance, SA 8000, ISO) adopted by your entity and aligned with each principle.",
  },
  {
    question:
      "5. Specific commitments, goals and targets set by the entity with defined timelines, if any",
    type: "text",
    values: {},
  },
  {
    question:
      "6. Performance of the entity against the specific commitments, goals and targets along with reasons in case the same are not met.",
    type: "text",
    values: {},
  },
];

const DisclosureTable = ({ disclosureData, setDisclosureData }) => {
  const handleInputChange = (rowIndex, principleKey, value) => {
    const updated = [...disclosureData];
    updated[rowIndex].values[principleKey] = value;
    setDisclosureData(updated);
  };

  const toggleYesNo = (rowIndex, principleKey) => {
    const updated = [...disclosureData];
    updated[rowIndex].values[principleKey] =
      !updated[rowIndex].values[principleKey];
    setDisclosureData(updated);
  };

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: "20px",
        maxWidth: "100%",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",

          fontSize: "12px",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={tableHeaderStyle}>Disclosure Questions</th>
            {principles.map((p) => (
              <th key={p} style={tableHeaderStyle}>
                {p}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {disclosureData.map((row, rowIndex) => (
            <tr key={rowIndex}>
              <td
                style={{ ...tableCellStyle, fontWeight: "bold" }}
                title={row.title}
              >
                {row.question}
              </td>
              {principles.map((principle) => {
                const isRow4to6 = rowIndex >= 5 && rowIndex <= 7;
                const isRow2 = rowIndex === 2;

                const placeholderMap = {
                  2: "Enter web link",
                  5: "Enter codes, labels, standards",
                  6: "Enter Commitments, goals, and targets with timelines",
                  7: "Enter Performance against commitments, goals, and targets",
                };

                const placeholder =
                  placeholderMap[rowIndex] || `Enter for ${principle}`;

                return (
                  <td key={principle} style={tableCellStyle}>
                    {row.type === "toggle" ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "4px",
                          fontSize: "11px",
                        }}
                      >
                        <span>No</span>
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={row.values?.[principle] || false}
                            onChange={() => toggleYesNo(rowIndex, principle)}
                          />
                          <span className="slider round"></span>
                        </label>
                        <span>Yes</span>
                      </div>
                    ) : isRow4to6 ? (
                      <textarea
                        value={row.values?.[principle] || ""}
                        placeholder={placeholder}
                        onChange={(e) =>
                          handleInputChange(rowIndex, principle, e.target.value)
                        }
                        style={multilineWideStyle}
                        rows={3}
                      />
                    ) : (
                      <input
                        type="text"
                        value={row.values?.[principle] || ""}
                        placeholder={placeholder}
                        onChange={(e) =>
                          handleInputChange(rowIndex, principle, e.target.value)
                        }
                        style={isRow2 ? compactInputStyle : inputFieldStyle}
                      />
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>

      {/* Toggle Switch CSS */}
      <style>{`
        .switch {
          position: relative;
          display: inline-block;
          width: 36px;
          height: 18px;
        }

        .switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }

        .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #ccc;
          transition: .4s;
          border-radius: 24px;
        }

        .slider:before {
          position: absolute;
          content: "";
          height: 12px;
          width: 12px;
          left: 3px;
          bottom: 3px;
          background-color: white;
          transition: .4s;
          border-radius: 50%;
        }

        input:checked + .slider {
          background-color: #8a4a68;
        }

        input:checked + .slider:before {
          transform: translateX(16px);
        }
      `}</style>
    </div>
  );
};

// Styles
const tableHeaderStyle = {
  padding: "6px",
  border: "1px solid #000",
  textAlign: "center",
  fontSize: "12px",
};

const tableCellStyle = {
  padding: "6px",
  border: "1px solid #000",
  textAlign: "center",
  verticalAlign: "middle",
  fontSize: "12px",
};

const inputFieldStyle = {
  width: "90%",
  padding: "4px",
  borderRadius: "3px",
  border: "1px solid grey",
  textAlign: "center",
  fontSize: "12px",
  backgroundColor: "white",
  outline: "none",
};

const compactInputStyle = {
  width: "85%",
  padding: "4px",
  borderRadius: "3px",
  border: "1px solid grey",
  textAlign: "left",
  fontSize: "11px",
  backgroundColor: "white",
};

const multilineWideStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "12px",
  backgroundColor: "white",
  resize: "vertical",
  textAlign: "left",
};

export default DisclosureTable;
